import React, { Component } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import history from './history';
import './App.css';
import Login from './auth_components/js/Login';
import HomePage from './Containers/HomePage';
import ProtectedRoutes from './ProtectedRoutes';
import LeaveContainer from './Containers/LeaveContainer';
import SettingsContainer from './Containers/SettingsContainer';
import ForgotPasswordContainer from './Containers/ForgotPasswordContainer';
import AccountsContainer from './Containers/AccountsContainer';
import LeaveApproveContainer from './Containers/LeaveApproveContainer';
import LeaveGrantContainer from './Containers/LeaveGrantContainer';
import GrievanceContainer from './Containers/GrievanceContainer';
import CertificateContainer from './Containers/CertificateContainer';
import { Suspense } from 'react';
import RouteLoading from './Components/Essentials/RouteLoading';


const CertificateLibraryContainer = React.lazy(() =>
  import("./Containers/CertificateLibraryContainer")
);

const CertificateVerificationContainer = React.lazy(() =>
  import("./Containers/CertificateVerificationContainer")
);

const CertificatePrincipalContainer = React.lazy(() =>
  import("./Containers/CertificatePrincipalContainer")
);

class App extends Component {
  
  render() {
    return (
      <Router history={history} >
        <Suspense fallback={<RouteLoading />}>
        <div>
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/forgotpassword" component={ForgotPasswordContainer} />
            <Route exact path="/" render={(props) => <HomePage {...props} />} />
            <Route exact path="/settings" component={SettingsContainer} />
            {/* <Route exact path="/attendance" component={AttendanceContainer} />
            <Route exact path="/takeattendance" component={AttendanceContainer} />
            <Route exact path="/editattendance" component={AttendanceContainer} />
            <Route exact path="/attendancereport" component={AttendanceContainer} /> */}
           {/*  <Route exact path="/feedback" component={FeedbackContainer} />
            <Route exact path="/feedback/:id" component={FeedbackContainer} /> */}

            {/* <Route exact path="/reportattendance" component={AttendanceReportContainer} />
            <Route exact path="/routine" component={RoutineContainer} />
            <Route exact path="/logbook" component={LogBookContainer} /> */}


            




            <Route exact path="/accounts" component={AccountsContainer} />
            <Route exact path="/accounts/accountheads" component={AccountsContainer} />
            <Route exact path="/accounts/accountsubheads" component={AccountsContainer} />
            <Route exact path="/accounts/payments" component={AccountsContainer} />
            <Route exact path="/accounts/opbalancehead" component={AccountsContainer} />
            <Route exact path="/accounts/opbalanceaccounts" component={AccountsContainer} />
            <Route exact path="/accounts/cashbook" component={AccountsContainer} />
            <Route exact path="/accounts/reports" component={AccountsContainer} />
            <Route exact path="/accounts/view" component={AccountsContainer} />

           
            <Route exact path="/leaveapprove" component={LeaveApproveContainer} />
            <Route exact path="/leavegrant" component={LeaveGrantContainer} />
<Route exact path="/grievance" component={GrievanceContainer} />

<Route
                  exact
                  path="/certificate"
                  component={CertificateContainer}
                />

                <Route
                  exact
                  path="/certificate-library"
                  render={(props) => <CertificateLibraryContainer {...props} />}
                />

                <Route
                  exact
                  path="/certificate-verification"
                  render={(props) => (
                    <CertificateVerificationContainer {...props} />
                  )}
                />

                <Route
                  exact
                  path="/certificate-principal"
                  render={(props) => (
                    <CertificatePrincipalContainer {...props} />
                  )}
                />

                <Route
                  exact
                  path="/certificate/certificatetype"
                  component={CertificateContainer}
                />
                <Route
                  exact
                  path="/certificate/certificateview"
                  component={CertificateContainer}
                />
                <Route
                  exact
                  path="/certificate/view"
                  component={CertificateContainer}
                />
                <Route
                  exact
                  path="/certificate/receipt-print"
                  component={CertificateContainer}
                />
                <Route
                  exact
                  path="/certificate/reports"
                  component={CertificateContainer}
                />
                <Route
                  exact
                  path="/certificate/print"
                  component={CertificateContainer}
                />

            <ProtectedRoutes pp={this.props} />
          </Switch>
        </div>
        </Suspense>
      </Router>
    );
  }
}

export default App;
